import { render, staticRenderFns } from "./captainCard.vue?vue&type=template&id=1d8b413e&scoped=true&"
import script from "./captainCard.vue?vue&type=script&lang=js&"
export * from "./captainCard.vue?vue&type=script&lang=js&"
import style0 from "./captainCard.vue?vue&type=style&index=0&id=1d8b413e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d8b413e",
  null
  
)

export default component.exports